import { useContext } from "react";
import { EnvironmentContext } from "../context/environment";

export default function useEnvironment() {
  return useContext(EnvironmentContext);
}
